<template>
	<div class="o-wrap">
		<el-page-header @back="$router.go(-1)" content="添加选手" />
		<NewForm @eventForm="handleGetForm" />
	</div>
</template>

<script>
	import NewForm from '@/components/Player/Form'
	export default {
		data() {
			return {
				ids:''
			}
		},
		created() {
			this.ids = this.$route.query.id
		},
		methods: {
			handleGetForm(form) {
				form.vote_id = this.ids
				this.$axios.post('Exhibition-Admin-addVotePlayerInfo', form).then(data => {
					console.log("添加选手",data)
					this.$message.success('发布成功');
					this.$router.push('/player?id='+this.ids)
				})
			}
		},
		components: {
			NewForm
		}
	}
</script>
